import * as React from 'react';
export const addSvg = React.forwardRef(function addSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.75.75a.75.75 0 0 0-1.5 0v2.5H.75a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5V.75Z',
    }),
  );
});
addSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var add = {
  category: 'icon',
  colorable: true,
  name: 'add',
  svg: addSvg,
};
